import React, { useState } from 'react';
import Icon from '../components/Icon';
import { Alert } from '../components/ui';
import SignInForm from './auth/SignInForm';
import SignUpForm from './auth/SignUpForm';
import ForgotPasswordForm from './auth/ForgotPasswordForm';
import ResetPasswordForm from './auth/ResetPasswordForm';
import heroImage from '../images/couple2.jpg';

const HERO_POINTS = [
  { icon: 'users', text: 'Real profiles with photo galleries' },
  { icon: 'chat', text: 'Instant conversations, no waiting' },
  { icon: 'sparkle', text: 'AI companions that talk like people' },
];

export default function AuthScreen({ resetToken, onResetDone, verifyNotice, onDismissVerifyNotice, onSignedIn }) {
  const [mode, setMode] = useState('signin');
  const view = resetToken ? 'reset' : mode;

  const copy = {
    signin: { heading: 'Welcome back', sub: 'Sign in to pick up where you left off.' },
    signup: { heading: 'Create your account', sub: 'It takes less than a minute to get started.' },
    forgot: { heading: 'Reset your password', sub: "Enter your email and we'll send you a reset link." },
    reset: { heading: 'Choose a new password', sub: 'Almost done — pick something you can remember.' },
  }[view];

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-hero">
          <img src={heroImage} alt="" />
          <div className="auth-hero-overlay">
            <div className="brand-mark">
              <span className="brand-mark-icon">
                <Icon name="flame" size={18} />
              </span>
              Date9
            </div>
            <div>
              <h1 className="auth-hero-headline">
                Meet someone
                <br />
                worth talking to.
              </h1>
              <p className="auth-hero-sub">
                Browse real people, swipe through matches, and start a conversation the moment it clicks.
              </p>
              <div className="auth-hero-points">
                {HERO_POINTS.map((point) => (
                  <div className="auth-hero-point" key={point.text}>
                    <Icon name={point.icon} size={16} />
                    {point.text}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="auth-panel">
          {verifyNotice && (
            <div style={{ marginBottom: 20 }}>
              <Alert kind={verifyNotice.ok ? 'success' : 'error'}>{verifyNotice.message}</Alert>
              <button type="button" className="link-btn" style={{ marginTop: 8 }} onClick={onDismissVerifyNotice}>
                Dismiss
              </button>
            </div>
          )}

          {view !== 'reset' && (
            <div className="auth-tabs" role="tablist" aria-label="Authentication">
              <button
                type="button"
                role="tab"
                aria-selected={view === 'signin'}
                className={`auth-tab${view === 'signin' ? ' active' : ''}`}
                onClick={() => setMode('signin')}
              >
                Sign in
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={view === 'signup'}
                className={`auth-tab${view === 'signup' ? ' active' : ''}`}
                onClick={() => setMode('signup')}
              >
                Sign up
              </button>
            </div>
          )}

          <h2 className="auth-heading">{copy.heading}</h2>
          <p className="auth-sub">{copy.sub}</p>

          {view === 'signin' && (
            <SignInForm onSignedIn={onSignedIn} onForgotPassword={() => setMode('forgot')} />
          )}
          {view === 'signup' && <SignUpForm onDone={() => setMode('signin')} />}
          {view === 'forgot' && <ForgotPasswordForm onBack={() => setMode('signin')} />}
          {view === 'reset' && (
            <ResetPasswordForm
              resetToken={resetToken}
              onDone={() => {
                setMode('signin');
                onResetDone();
              }}
            />
          )}

          {view === 'signup' && (
            <p className="auth-footnote">
              By creating an account you agree to be respectful to the people you meet here.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
